import {EntityDto} from '../../../../../services/dto/entityDto'
import {PagedResultDto} from '../../../../../services/dto/pagedResultDto'
import axios from 'axios'
import {CreateOrUpdateUserInput} from './dto/createOrUpdateUserInput'
import {UpdateUserInput} from './dto/updateUserInput'
import {ChangeLanguagaInput} from './dto/changeLanguageInput'
import {PagedUserResultRequestDto} from './dto/PagedUserResultRequestDto'
import {GetAllUserOutput} from './dto/getAllUserOutput'

const API_URL = process.env.REACT_APP_SERVICE_API_URL
export const URL_CREATE = `${API_URL}/User/CreateUser`
export const URL_UPDATE = `${API_URL}/User/Update`
export const URL_DELETE = `${API_URL}/User/Delete`
export const URL_GET_USER_ROLES = `${API_URL}/User/GetRoles`
export const URL_POST_CHANGE_LANGUAGE = `${API_URL}/User/ChangeLanguage`
export const URL_GET = `${API_URL}/User/Get`
export const URL_GET_ALL = `${API_URL}/User/GetAll`
export const URL_GET_Detail = `${API_URL}/Profile/GetUserDetail`

export function onCreateUser(createUserInput: CreateOrUpdateUserInput) {
  return axios.post(URL_CREATE, createUserInput)
}

export function onUpdateUser(updateUserInput: UpdateUserInput) {
  return axios.put(URL_UPDATE, updateUserInput)
}

export function onDeleteUser(entityDto: EntityDto) {
  return axios.delete(URL_DELETE, {params: entityDto})
}

export function onGetUserRoles() {
  return axios.get(URL_GET_USER_ROLES)
}

export function onChangeLanguage(changeLanguageInput: ChangeLanguagaInput) {
  return axios.post(URL_POST_CHANGE_LANGUAGE, changeLanguageInput)
}

export function onGetUserDetail() {
  return axios.get(URL_GET_Detail)
}

export function onGetUser(entityDto: EntityDto): Promise<CreateOrUpdateUserInput> {
  return axios.get(URL_GET, {params: entityDto})
}

export function onGetAllUsers(
  pagedFilterAndSortedRequest: PagedUserResultRequestDto
): Promise<PagedResultDto<GetAllUserOutput>> {
  return axios.get(URL_GET_ALL, {params: pagedFilterAndSortedRequest})
}
